<template>
    <div class="home">
        <!-- top -->
        <div class="topWrap">
            <div class="topLogo">
                <img class="logo" src="../../assets/images/logo.png" alt="">
            </div>
            <div class="topRt">
                <div class="topSearch">
                    <input class="search" 
                        :class="!isVisible ? 'opc' : ''"  
                        v-model="searchValue" 
                        key="search"
                        ref="search"
                        placeholder="请输入企业关键字"
                        @blur="blur"
                        @keyup.enter="hanldeSearchClick"
                    >
                    <img class="searchIcon" v-if="isVisible"  @click="show" src="../../assets/images/search_icon.png" alt="">
                    <img class="searchIcon" @click="hanldeSearchClick" v-else src="../../assets/images/search_active.png" alt="">
                </div>
                <div class="topMenu">
                    <img src="../../assets/images/menu_icon.png" alt="">
                </div>
            </div>
        </div>
        <div class="container">
            <header class="top">
                <!-- <div class="topWrap">
                    <div class="topLogo">
                        <img class="logo" src="../../assets/images/logo.png" alt="">
                    </div>
                    <div class="topRt">
                        <div class="topSearch">
                            <input class="search" 
                                :class="!isVisible ? 'opc' : ''"  
                                v-model="searchValue" 
                                key="search"
                                ref="search"
                                @blur="blur"
                            >
                            <img class="searchIcon" v-if="isVisible"  @click="show" src="../../assets/images/search_icon.png" alt="">
                            <img class="searchIcon"  v-else src="../../assets/images/search_active.png" alt="">
                        </div>
                        <div class="topMenu">
                            <img src="../../assets/images/menu_icon.png" alt="">
                        </div>
                    </div>
                </div> -->
            </header>
            <!-- nav -->
            <nav class="nav">
                <ul class="list">
                    <router-link class="lis" tag="li" to="/news">
                        <img class="icon" src="../../assets/images/news_icon.png" alt="">
                        <p class="words">新闻资讯</p>
                    </router-link>
                    <router-link class="lis" tag="li" to="/activity">
                        <img class="icon" src="../../assets/images/activity_icon.png" alt="">
                        <p class="words">文旅活动</p>
                    </router-link>
                    <router-link class="lis" tag="li" to="/item">
                        <img class="icon" src="../../assets/images/item_icon.png" alt="">
                        <p class="words">招标项目</p>
                    </router-link>
                    <router-link class="lis" tag="li" to="/mall">
                        <img class="icon" src="../../assets/images/mall_icon.png" alt="">
                        <p class="words">文创商城</p>
                    </router-link>
                    <router-link class="lis" tag="li" to="/equity">
                        <img class="icon" src="../../assets/images/equity_icon.png" alt="">
                        <p class="words">知识产权</p>
                    </router-link>
                    <router-link class="lis" tag="li" :to="{name: 'Policy',query: {id: '600e099e4c59486ab7a34b11b1429aae',title: '扶持政策'}}">
                        <img class="icon" src="../../assets/images/policy_icon.png" alt="">
                        <p class="words">扶持政策</p>
                    </router-link>
                    <router-link class="lis" tag="li" to="/bloc">
                        <img class="icon" src="../../assets/images/bloc_icon.png" alt="">
                        <p class="words">产业联盟</p>
                    </router-link>
                    <router-link class="lis zg" tag="li" to="/pavilion">
                        <img class="icon" src="../../assets/images/pavilion_icon.png" alt="">
                        <p class="words">虚拟展馆</p>
                    </router-link>
                    <router-link class="lis" tag="li" to="/about">
                        <img class="icon" src="../../assets/images/about_icon.png" alt="">
                        <p class="words">关于我们</p>
                    </router-link>
                </ul>
            </nav>
            <!-- 新闻资讯 -->
            <section class="public">
                <div class="box">
                    <span class="title">新闻资讯</span>
                    <span class="line"></span>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <div class="swiper">
                    <swiper :options="swiperOption" v-if="swiperList.length">
                        <swiper-slide v-for="item in swiperList" :key="item.id">
                            <router-link tag="div" class="slideBox" :to="{name: 'Detail',query:{id: item.id,mode: 'ARTICLE'}}">
                                <img :src="item.image" alt="">
                            </router-link>
                        </swiper-slide>
                        <div class="swiper-pagination"  slot="pagination"></div>
                    </swiper> 
                </div>
                <div class="content" >
                    <h1 class="title" >{{ selectNewsList.title }}</h1>
                    <p class="text" >
                        {{ selectNewsList.description }}
                    </p>
                </div>
            </section>
            <!-- 文旅活动 -->
            <section class="public">
                <div class="box">
                    <span class="title">文旅活动</span>
                    <span class="line"></span>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <ul class="doingList">
                    <router-link 
                        tag="li"  
                        class="lis" 
                        v-for="item in activityList" 
                        :key="item.id"
                        :to="{name: 'Detail', query:{ id:item.id,mode: 'ARTICLE'}}"
                    >
                        <div class="iconBox">
                            <img :src="item.image" alt="">
                        </div>
                        <div class="rt">
                            <p class="doingTitle">
                                {{ item.title }}
                            </p>
                            <p class="times">{{ item.createDate.split(' ')[0] }}</p>
                        </div>
                    </router-link>
                </ul>
            </section>
            <!-- footer -->
            <footer class="footer">
                <p>
                    版权所有 济南市历下区文化产业协会<br>
                    Copyright © 2019 JNCIA.All rights Reserved
                </p>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "home",
    data() {
        return {
            searchValue: '',
            isVisible: true,
            swiperList: [],
            swiperOption: {
                observer:true,
                observeParents:true,
                autoplay: {
                    disableOnInteraction: false,
                    delay: 3000
                },
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    bulletClass : 'my-bullet',
                    bulletActiveClass: 'my-bullet-active',
                },
                on:{
                    paginationUpdate: (e) =>{
                        this.selectNewsList = this.swiperList[e.realIndex]
                    }
                },
            },
            selectNewsList: '', // 对应的新闻资讯
            activityList: []    //  文旅活动
        };
    },
    watch: {
        current: function(val){
            console.log(val,123);
        }
    },
    mounted() {
        // 获取新闻资讯轮播内容
        this.getNewsList()
        // 获取文旅活动
        this.geiActivityList()
    },
    methods: {
        show() {
            this.isVisible = false
            this.$refs.search.focus()
        },
        blur() {
            // this.isVisible = true
        },
        // 搜索关键字
        hanldeSearchClick() {
            if(!this.searchValue){
                this.$toast.fail('请输入有效关键字');
                return
            }
            this.$router.push({name: 'Policy', query: {val: this.searchValue}})
        },
        // 获取新闻资讯
        getNewsList() {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/mobilecarousel',
                method: 'GET',
            }).then(res => {
                if(res.data.code == 0){
                    this.swiperList = res.data.xwzxThree
                    console.log(this.swiperList);
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 获取文旅活动
        geiActivityList(pageNo=1, pageSize=10) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/listByCategoryId',
                method: 'GET',
                params: {
                    categoryId: '07e2377534064779936d4e0e61a54637 ',
                    pageNo,
                    pageSize,
                    contentType: 'ARTICLE'
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.activityList = res.data.page.list
                    console.log(this.activityList);
                }
            }).catch(err => {
                console.log(err.response);
            })
        }
    },
};
</script>

<style scoped>
.home{
    background: #F2F3F7;
}
/* top */
.top{
    width: 100%;
    height: 3.6rem;
    background: url('../../assets/images/top_bg.png') no-repeat;
    background-size: cover;
    margin-top: -1rem;
}
.topWrap{
    height: 1rem;
    padding: 0 .3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(to bottom,#565555,#fff);
    position: relative;
    z-index: 1;
}
.container{
    position: absolute;
    top: 1rem;
    width: 100%;
    height: calc(100vh - 1rem);
    overflow: auto;
}
.topWrap .logo{
    width: 1.66rem;
}
.topWrap .topRt{
    display: flex;
    align-items: center;
}
.topWrap .topSearch{
    position: relative;
    width: 3.6rem;
    height: .6rem;
    line-height: .6rem;
    display: flex;
    align-items: center;
    margin-right: .34rem;
}
.topWrap .topSearch .search{
    width: 0;
    box-sizing: border-box;
    border-radius: .3rem;
    text-indent: .2rem;
}
.topWrap .topSearch .opc{
    width: 100%;
    height: 100%;
    transition: .5s ease;
    border: .02rem solid #fff;
}
.topWrap .topSearch .searchIcon{
    width: .3rem;
    padding: .1rem;
    position: absolute;
    right: .1rem;
    top: 0;
    bottom: 0;
    margin: auto;
}
/* nav */
.list{
    display: flex;
    flex-wrap: wrap;
    background: #fff;
}
.list .lis{
    width: 20%;
    height: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: .2rem 0;
}
.list .zg .icon{
    width: 16px;
    height: 15px;
}
.list .lis .words{
    margin-top: .1rem;
}
/* 新闻资讯 */
.public{
    margin-top: .2rem;
    padding: 0 .3rem;
    background: #fff;
}
.public .box{
    position: relative;
    height: .88rem;
    display: flex;
    /* align-items: center; */
}
.public .box .title{
    font-weight: bold;
    font-size: .28rem;
    color: #D60000;
    margin-top: .3rem;
}
.public .box .line{
    height: 0.02rem;
    background: #D60000;
    margin-top: .56rem;
    margin-left: .14rem;
    flex-grow: 1;
}
.public .box .bd{
    position: absolute;
    right: 0;
    top: .44rem;
}
.public .swiper{
    height: 3.3rem;
}
.public .swiper .swiper-slide{
    display: flex;
    align-items: center;
    height: 3.3rem;
}
.public .swiper img{
    width: 100%;
    max-height: 100%;
}
.slideBox{
    width: 100%;
    display: flex;
    align-items: center;
    height: 3.3rem;
}
.public .swiper >>> .my-bullet{
    background: #333;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 4px;
}
.public .swiper >>> .my-bullet-active{
    width: 20px;
    border-radius: 3px;
    background: #fff;
    opacity: 1;
}
.public .content {
    padding-bottom: .2rem;
}
.public .content .title{
    height: .64rem;
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #333;
    font-size: .28rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.public .content .text{
    line-height: 2;
    color: #666;
    font-size: .24rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    margin-top: .1rem;
}
/* 文旅活动 */
.public .doingList{
    overflow: hidden;
}
.public .doingList .lis{
    display: flex;
    margin-bottom: .3rem;
}
.public .doingList .lis .iconBox{
    width: 1.8rem;
    height: 1.2rem;
    margin-right: .2rem;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.public .doingList .lis .iconBox img{
    width: 100%;
    height: 100%
}
.public .doingList .lis .rt{
    width: 4.8rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.public .doingList .lis .rt .doingTitle{
    line-height: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.public .doingList .lis .rt .times{
    color: #999;
}
/* footer */
.footer{
    width: 100%;
    height: 1.5rem;
    background: #D60000;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: .2rem;
}
.footer p{
    color: #fff;
    text-align: center;
    line-height: 2;
}
</style>
